import io from 'socket.io-client';
import { SIGNALING_CONFIG } from '../signaling-config';

const SIGNALING_SERVER_URL = SIGNALING_CONFIG.serverUrl

export class SignalingClient {
  constructor() {
    this.socket = null;
    this.listeners = {};
  }

  connect(serverUrl = SIGNALING_SERVER_URL) {
    this.socket = io(serverUrl, {
      path: '/webrtc/'
    });

    this.socket.on('connect', () => {
      this.emit('connected', this.socket.id);
    });

    this.socket.on('disconnect', () => {
      this.emit('disconnected');
    });

    // Forward all signaling events
    const events = [
      'room-created', 'room-joined', 'room-error', 
      'peer-joined', 'peer-left', 'offer', 'answer', 
      'ice-candidate', 'peer-disconnected'
    ];

    events.forEach(event => {
      this.socket.on(event, (data) => {
        this.emit(event, data);
      });
    });

    return this.socket;
  }

  on(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);
  }

  emit(event, data) {
    if (this.listeners[event]) {
      this.listeners[event].forEach(callback => callback(data));
    }
  }

  createRoom(roomId) {
    this.socket.emit('create-room', roomId);
  }

  joinRoom(roomId) {
    this.socket.emit('join-room', roomId);
  }

  leaveRoom(roomId) {
    this.socket.emit('leave-room', roomId);
  }

  sendOffer(roomId, offer) {
    this.socket.emit('offer', { roomId, offer });
  }

  sendAnswer(roomId, answer) {
    this.socket.emit('answer', { roomId, answer });
  }

  sendIceCandidate(roomId, candidate) {
    this.socket.emit('ice-candidate', { roomId, candidate });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  getSocketId() {
    return this.socket ? this.socket.id : null;
  }
}